import styled from 'styled-components';

export type TStatusBadgeColor =
  | 'green'
  | 'yellow'
  | 'gray'
  | 'red'
  | 'pink'
  | 'blue'
  | 'darkPink';

type Props = {
  color: TStatusBadgeColor;
};
export const StatusBadge = styled.span<Props>`
  background-color: ${({ color, theme }) => theme.statusColors[color].bg};
  color: ${({ color, theme }) => theme.statusColors[color].color};
  padding: 6px 12px;
  font-size: 0.875rem;
  border-radius: 6px;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
`;

export const StatusDescription = styled.span<Props>`
  color: ${({ color, theme }) => theme.statusColors[color].color};
`;
